/* Wild Honeybee — reviews block under Add to cart
   1) stars by the price scroll to the reviews
   2) show 3 reviews by default with a "Read all N reviews" button */
(function () {
  var SEL = '.section-product-info .jdgm-review-widget';

  document.addEventListener('click', function (e) {
    var r = e.target.closest('.section-product-info .rating');
    if (!r) return;
    var w = document.querySelector(SEL);
    if (!w) return;
    e.preventDefault();
    w.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function setup() {
    var w = document.querySelector(SEL);
    if (!w || w.dataset.whbReady) return false;
    var list = w.querySelector('.jdgm-review-list');
    if (!list || !list.querySelector('.jm-review-item')) return false;
    w.dataset.whbReady = '1';

    var countEl = w.querySelector('.jm-average-rating-display__review-count');
    var m = countEl && countEl.textContent.match(/\d+/);
    var total = m ? parseInt(m[0], 10) : list.querySelectorAll('.jm-review-item').length;
    if (total <= 3) return true;

    w.classList.add('whb-collapsed');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'whb-read-all';
    btn.textContent = 'Read all ' + total + ' reviews';
    btn.addEventListener('click', function () {
      w.classList.remove('whb-collapsed');
      btn.remove();
    });
    list.insertAdjacentElement('afterend', btn);
    return true;
  }

  if (!setup()) {
    var obs = new MutationObserver(function () { if (setup()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }
})();

/* 3) delivery cut-off countdown: always count down to the cut-off in UK time,
      whatever the visitor's own clock says (the theme compares against local time) */
document.addEventListener('alpine:initialized', function () {
  var store = window.Alpine && window.Alpine.store('xEstimateDelivery');
  if (!store || typeof store.countdownCutOffTime !== 'function') return;
  store.countdownCutOffTime = function (cutOffHour, cutOffMinute, hrsText, minsText) {
    if (this.noti !== '') return;
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? parseInt(p.value, 10) : 0; };
    var nowMins = get('hour') * 60 + get('minute');
    var cutMins = parseInt(cutOffHour, 10) * 60 + parseInt(cutOffMinute, 10);
    var diff = cutMins - nowMins;
    if (diff <= 0) diff += 24 * 60;
    this.hour = Math.floor(diff / 60);
    this.minute = diff % 60;
    this.noti = this.hour > 0
      ? this.hour + ' ' + hrsText + ' ' + this.minute + ' ' + minsText
      : this.minute + ' ' + minsText;
  };
});
